<template>
  <LabelledInput label="Chart style">
    <b-radio
      v-model="chartStyle"
      value="pie"
    >
      Pie Chart
    </b-radio>
    <b-radio
      v-model="chartStyle"
      value="donut"
    >
      Donut Chart
    </b-radio>
  </LabelledInput>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

const components = {
  LabelledInput,
}

@Component({ components })
export default class PieDonut extends Vue {
  get chartStyle () {
    return this.$typedStore.primary.app.config.appConfig.graphStyle
  }

  set chartStyle (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: ['appConfig', 'graphStyle'],
      value: newValue,
    })

    // Toggle the graph to re-draw the d3 graph
    this.$emit('toggleGraph')
  }
}
</script>
